export default __webpack_public_path__ + "static/media/HappySongkanDay.d661db34.jpg";